/**
 * Created by Ivan on 10.08.2026
 */

const Sticker2 = function (options) {
    cleverapps.EventEmitter.call(this);

    this.collection = options.collection;
    this.image = options.image;
    this.title = options.title;
    this.state = options.state;
    this.rarity = options.rarity;
    this.attention = options.attention && this.isOpen();
};

Sticker2.prototype = Object.create(cleverapps.EventEmitter.prototype);
Sticker2.prototype.constructor = Sticker2;

Sticker2.prototype.open = function (source) {
    if (this.getState() === Sticker2.STATE_CLOSED) {
        this.state = Sticker2.STATE_OPENED;
        this.setAttention(true);

        this.trigger("update");
        cleverapps.metrics.logEvent(cleverapps.EVENTS.STICKER2_OPEN + source);
    }
};

Sticker2.prototype.setAttention = function (state) {
    this.attention = state;
    this.trigger("update");

    cleverapps.stickersBook2.onChangeAttentionListener();
    cleverapps.stickersBook2.save();
};

Sticker2.prototype.getViewClass = function () {
    return StickersBook2.isPuzzle() ? PuzzleStickerView2 : StickerView2;
};

Sticker2.prototype.getIndex = function () {
    return this.collection.stickers.indexOf(this);
};

Sticker2.prototype.hasAttention = function () {
    return this.attention;
};

Sticker2.prototype.getState = function () {
    return this.state;
};

Sticker2.prototype.isOpen = function () {
    return this.state === Sticker2.STATE_OPENED;
};

Sticker2.prototype.isRare = function () {
    return this.rarity === StickersCollection2.RARITIES[StickersCollection2.RARITIES.length - 1];
};

Sticker2.prototype.getStarsAmount = function () {
    return Math.min(this.rarity + 1, 5);
};

Sticker2.STATE_CLOSED = 0;
Sticker2.STATE_OPENED = 1;

Sticker2.SOURCES = {
    buy: "buy",
    level: "level",
    dailyTasks: "daily",
    support: "support",
    weeklyGoals: "weekly",
    tutorial: "tutorial"
};